export enum GeoTestMethod {
  manual = 'MANUAL',
  auto = 'AUTO'
}
